export const unitList = [
  {
    id: 0,
    label: 'Bin',
    base: 2,
  },
  {
    id: 1,
    label: 'Oct',
    base: 8,
  },
  {
    id: 2,
    label: 'Dec',
    base: 10,
  },
  {
    id: 3,
    label: 'Hex',
    base: 16,
  },
];

export const getMaxLengths = () => ({
  2: 32,
  8: 10,
  10: 9,
  16: 8,
});

export const MAX_32_BIT_SIGNED_INTEGER = Math.pow(2, 31) - 1;

export const LETTER_ELEMENTS = ['A', 'B', 'C', 'D', 'E', 'F'];

export const OPERATORS = ['+', '-', '*', '/'];

export const VALID_INPUT_REGULAR_EXPRESSIONS = {
  2: /(^[0-1]*$)/,
  8: /(^[0-7]*$)/,
  10: /(^-?[0-9]*$)|(^0$)/,
  16: /(^[0-9A-F]*$)|(^0$)/,
};
